import twoDigitFormat from "./two.digit.format";

/**
 * Генерирует даты date_from и date_to на основе выбранного периода
 * @param {Object} statsPeriod - объект с id и name периода (today, yesterday, week, month, year, period)
 * @param {Object} statsCurrent - объект с id и name (current, past) - используется для week, month, year
 * @param {Object} customDates - объект с dateFrom и dateTo для периода 'period'
 * @returns {Object} объект с date_from и date_to в формате 'YYYY-MM-DD'
 */
function generateStatsDates(statsPeriod, statsCurrent = null, customDates = null) {
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = twoDigitFormat(date.getMonth() + 1);
    const day = twoDigitFormat(date.getDate());
    return `${year}-${month}-${day}`;
  };

  const getWeekStart = (date) => {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1); // Понедельник как начало недели
    return new Date(d.setDate(diff));
  };

  const getWeekEnd = (date) => {
    const start = getWeekStart(date);
    const end = new Date(start);
    end.setDate(start.getDate() + 6); // Воскресенье
    return end;
  };

  const getMonthStart = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  };

  const getMonthEnd = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  };

  const getYearStart = (date) => {
    return new Date(date.getFullYear(), 0, 1);
  };

  const getYearEnd = (date) => {
    return new Date(date.getFullYear(), 11, 31);
  };

  const periodId = statsPeriod?.id || statsPeriod;
  const currentId = statsCurrent?.id || statsCurrent;

  switch (periodId) {
    case 'today': {
      return {
        date_from: formatDate(today),
        date_to: formatDate(today)
      };
    }

    case 'yesterday': {
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      return {
        date_from: formatDate(yesterday),
        date_to: formatDate(yesterday)
      };
    }

    case 'week': {
      let baseDate = new Date(today);
      
      if (currentId === 'past') {
        // Прошлая неделя
        baseDate.setDate(baseDate.getDate() - 7);
      }
      
      const weekStart = getWeekStart(baseDate);
      const weekEnd = getWeekEnd(baseDate);
      
      return {
        date_from: formatDate(weekStart),
        date_to: formatDate(weekEnd)
      };
    }

    case 'month': {
      let baseDate = new Date(today);
      
      if (currentId === 'past') {
        // Прошлый месяц
        baseDate.setMonth(baseDate.getMonth() - 1);
      }
      
      const monthStart = getMonthStart(baseDate);
      const monthEnd = getMonthEnd(baseDate);
      
      return {
        date_from: formatDate(monthStart),
        date_to: formatDate(monthEnd)
      };
    }

    case 'year': {
      let baseDate = new Date(today);
      
      if (currentId === 'past') {
        // Прошлый год
        baseDate.setFullYear(baseDate.getFullYear() - 1);
      }
      
      const yearStart = getYearStart(baseDate);
      const yearEnd = getYearEnd(baseDate);
      
      return {
        date_from: formatDate(yearStart),
        date_to: formatDate(yearEnd)
      };
    }

    case 'period': {
      // Для периода используем кастомные даты из формы
      if (customDates?.dateFrom && customDates?.dateTo) {
        return {
          date_from: customDates.dateFrom,
          date_to: customDates.dateTo
        };
      }
      // Если даты не указаны, возвращаем текущую дату
      return {
        date_from: formatDate(today),
        date_to: formatDate(today)
      };
    }

    default: {
      // По умолчанию возвращаем текущую дату
      return {
        date_from: formatDate(today),
        date_to: formatDate(today)
      };
    }
  }
}

export default generateStatsDates;

